/**
 * HealthProfessionalTypesStore
 * Extends the BaseStore for managing HealthProfessionalTypes.
 */

import BaseStore from '@legacy-src/Datastores/BaseStore';
import { HealthProfessionalTypeInterface } from '@sah/Classes/HealthProfessionalType';

class HealthProfessionalTypesStore extends BaseStore<HealthProfessionalTypeInterface> {}

export default new HealthProfessionalTypesStore();
